import img1 from '../assests/img1.jpg'
import img2 from '../assests/img2.jpg'
import img3 from '../assests/img3.jpg'
import img4 from '../assests/img4.jpg'
import img5 from '../assests/img5.jpg'
import img6 from '../assests/img6.jpg'
import img7 from '../assests/img7.jpg'
import img8 from '../assests/img8.jpg'
import img9 from '../assests/img9.jpg'
import img10 from '../assests/img10.jpg'
import img11 from '../assests/img11.jpg'
import img12 from '../assests/img12.jpg'

import img14 from '../assests/img14.jpg'

export const SliderProducts = [{
    name:'SKIN',
    detail:'Super SKin Care',
    price:'25',
    img:img1
},
{
    name:'SKIN',
    detail:'Super SKin Care',
    price:'30',
    img:img2
},

{
    name:'NATURE',
    detail:'Super SKin Care',
    price:'45',
    img:img3
}
]

export const ProductsData = [{
    name: 'FOUNDATION',
    detail: 'Super Skin Care',
    price: '25',
    img: img1,
    type: 'Foundation',
},

{
    name: 'CONDITIONERS',
    detail: 'Super Skin Care',
    price: '35',
    img: img2,
    type: 'conditioners',
},
{
    name: 'CONDITIONERS',
    detail: 'Super Skin Care',
    price: '55',
    img: img3,
    type: 'conditioners',
},{
    name: 'FOUNDATION',
    detail: 'Super Skin Care',
    price: '75',
    img: img4,
    type: 'Foundation',
},
{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '60',
    img: img5,
    type: 'skin care',
},

{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '90',
    img: img6,
    type: 'Foundation',
},
{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '40',
    img: img7,
    type: 'skin care',
},
{
    name: 'CONDITIONERS',
    detail: 'Super Skin Care',
    price: '95',
    img: img8,
    type: 'conditioners',
},
{
    name: 'FOUNDATION',
    detail: 'Super Skin Care',
    price: '100',
    img: img9,
    type: 'Foundation',
},

{
    name: 'FOUNDATION',
    detail: 'Super Skin Care',
    price: '30',
    img: img10,
    type: 'Foundation',
},
{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '80',
    img: img11,
    type: 'skin care',
},{
    name: 'CONDITIONERS',
    detail: 'Super Skin Care',
    price: '255',
    img: img12,
    type: 'conditioners',
},


{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '85',
    img: img14,
    type: 'skin care',
}

]